import styled from "styled-components";

import { Grid, Container, IconButton, Icon } from "@material-ui/core";

/* -------- Estilização ---------- */

const primary = (props) => props.theme.palette.primary;
const secondary = (props) => props.theme.palette.secondary;
const montserrat = (props) => props.theme.fonts.montserrat;
const mulish = (props) => props.theme.fonts.mulish;

export const MarginRightIcon = styled(Icon)`
  margin-right: 10px;
`;

export const BallContainer = styled.div`
  img {
    width: 20px;
    transform: translateX(-50%);
  }
`;

export const PainelContainer = styled(Container)`
  margin-top: 15vh;
`;

export const AriaInput = styled(Grid)`
  .MuiInputBase-root {
    input {
      font-family: ${montserrat}, sans-serif !important;
    }
  }

  label {
    padding: 0px;
    font-family: ${montserrat}, sans-serif !important;
  }

  .MuiFormControl-root {
    width: 100%;
  }

  .MuiButton-contained {
    width: 100%;
    height: 100%;
  }
`;

export const TableContent = styled.div`
  Table {
    min-width: 0px !important;
    Thead {
      background-color: ${secondary};
      box-shadow: 3px 3px 3px ${(props) => props.theme.palette.darkgrey};
      tr {
        th {
          span {
            font-family: ${montserrat}, sans-serif !important;
          }
        }
      }
    }
    Tbody {
      tr {
        height: 0px !important;
      }
      td {
        font-family: ${montserrat}, sans-serif !important;
      }
    }
  }
`;

export const HeaderAccordion = styled.div`
  width: 100%;

  .MuiChip-root {
    cursor: pointer;
    padding: 20px;
    width: 100%;
    margin: 0;
    span {
      font-weight: bolder;
      font-family: ${mulish};
      font-size: 1.2rem;
    }
  }
`;

export const HeaderCard = styled.div`
  width: 100%;

  .MuiChip-root {
    padding: 10px;
    width: 100%;
    margin: 0;
    span {
      font-weight: bolder;
      font-family: ${mulish};
      font-size: 1rem;
    }
  }
`;

export const IconButtonStyled = styled(IconButton)`
  background-color: ${primary} !important;
  color: white !important;

  :hover {
    background-color: orange !important;
  }
`;
